import Vue from 'vue';
import $ from 'jquery';

Vue.component('spabooking',  {
    props: {
        baseUrl: {
            type: [String, RegExp],
            required: true,
        },

        validBookingPeriod: {
            type: Number,
            required: false,
            default: 90
        },

        maxGroupSizeMessage: {
            type: String,
            required: true
        },

        groupBookingMessage: {
            type: String,
            required: true
        },

        cancellationMessage: {
            type: String,
            required: true
        },

        maximumGuestsDropdownText: {
            type: String,
            required: false
        },

        maxGroupSize: {
            type: Number,
            required: true,
        },
    },
    data: function () {
        return {
            date: null,
            defaultText: null,
            startDate: null,
            endDate: null,
            numberOfGuests: null,
            maximumGroupSize: null,
            cancellationMessageToggle: false
        }
    },

    mounted: function () {
        this.guestSelectInit();
    },

    methods: {
        guestSelectInit() {
            const spaSelectId = ".js-spa-booking-guests"
            $(spaSelectId).select2({
                dropdownParent: $(spaSelectId).parents('.booking__select'),
                minimumResultsForSearch: -1,
                allowClear: true,
                placeholder: window.GuestsDropdownFirstItem,
                dropdownCssClass: ""
            }).on('change', event => {
                this.numberOfGuests = $(".js-spa-booking-guests").val();
            });
            
            $(spaSelectId).on('select2:open', function (e) {
                const evt = "scroll.select2";
                $(e.target).parents().off(evt);
                $(window).off(evt);

                const bookingTabs = $(".booking-menu-tabs__content")

                bookingTabs.each(function () {
                    $(this).addClass("overflow-none")
                });
            }).on('select2:close', function (e) {
                const bookingTabs = $(".booking-menu-tabs__content")

                bookingTabs.each(function () {
                    $(this).removeClass("overflow-none")
                });
            });

            const parentSpa = $(spaSelectId).parent()
            if (parentSpa.length) {
                const labelIdSpa = parentSpa.find("label")[0].id;
                const singleSelectionSpa = parentSpa.find(".select2-selection--single")
                singleSelectionSpa.first().attr("aria-labelledby", labelIdSpa)
            }
        },

        showCancellationMessage: function (show) {
            this.cancellationMessageToggle = show
        },

        spaBookingSubmit: function () {
            let queryParams = new URLSearchParams(document.location.search);
            if (this.numberOfGuests > 0) queryParams.append('guestNoChecker', this.numberOfGuests)
            if (this.date !== null) queryParams.append('dateChecker', this.date)
            sessionStorage.clear();
            if (this.date !== null && this.numberOfGuests > 0) {
                window.location.href = this.baseUrl + "#/treatments?" + queryParams
            }
            window.location.href = this.baseUrl + "#?" + queryParams
        },

        updateDate: function (date) {
            this.date = date;
        },

    },
    template: '#spaBookingComponent'
});